require('sticky-sidebar/dist/jquery.sticky-sidebar.min.js');
require('./files/information');

require('../../sass/web/information.scss');